import type { SpenderNotification, SpenderNotificationList } from '../api/types.ts';

/** Where a notification leads: the entry's messages for a note, Home for cash (the Received banner). */
export function noteLink(n: Pick<SpenderNotification, 'kind' | 'transactionId'>): string {
  if (n.kind === 'needs_fix') return `/history?status=needs_correction&open=${n.transactionId}`;
  if (n.kind === 'rejected') return `/history?status=rejected&open=${n.transactionId}`;
  return '/';
}

/** Local copy with one notification read (shown at once, before the server answers). */
export function withRead(list: SpenderNotificationList, id: string): SpenderNotificationList {
  const target = list.items.find((n) => n.id === id);
  if (!target || target.read) return list;
  return {
    unread: Math.max(0, list.unread - 1),
    items: list.items.map((n) => (n.id === id ? { ...n, read: true } : n)),
  };
}

/** Changes whenever anything the office boy can see changes (new, re-sent, read, decided). */
export function signature(list: SpenderNotificationList | null): string {
  if (!list) return '';
  return `${list.unread}|${list.items.map((n) => `${n.id}:${n.createdAt}:${n.status}:${n.read ? 1 : 0}`).join(',')}`;
}
